export const getMaxLength = (id: string): number | undefined => {
  switch (id) {
    case "new_password":
    case "confirm_password":
    case "password":
      return 16; // Max length for password
    case 'phone_number':
      return 20;
    case 'city_town':
    case 'street_name':
    case 'province':
    case 'region':
    case 'district':
    case 'postal_code':
      return 30;
    case 'house_no':
    case 'market_block_no':
    case 'floor_no':
      return 15;
    case 'bank_name':
      return 64;
    case 'bank_account_number':
      return 25;
    case 'office_no':
      return 25;
    case 'national_id_number':
    case 'hesabpay_account_number':
      return 20;
    case 'business_license_number':
      return 25;
    case 'min_recharge_amount':
    case 'max_recharge_amount':
    case 'etopup_target_value':
    case 'bundle_target_value':
    case 'amount':
    case 'associated_phone_number':
      return 15;
    default:
      return 50; // No restriction for other fields
  }
};
